<template>
    <div class="orderItem" @click="goDetail">
        <OrderAddress
            :distance="rows.distance"
            :shopName="supplierName"
            :address="supplierAddress"
            :lat="supplierLat"
            :lng="supplierLng"
            :statusLabel="statusLabel"
            :statusColor="statusColor"
        />
        <div class="dateGroup" v-if="rows.orderservice">
            <div class="dateItem">
                <div>{{ rows.orderservice.service_name }}</div>
                <div style="margin: 0.25rem 0;font-size:1.2rem">{{ formatTimestamp(rows.orderservice.start_time, 'YYYY-MM-DD') }}</div>
                <div class="dateTime">
                    <div>{{ formatTimestamp(rows.orderservice.start_time, 'HH:mm') }}</div>
                    <div class="line"></div>
                    <div>{{ formatTimestamp(rows.orderservice.end_time, 'HH:mm') }}</div>
                    <div style="margin-left:5px">({{ getMinute(rows.orderservice.minute, rows.orderservice.hour) }} min)</div>
                </div>
                <div class="applyDesc">Reason: {{ rows.apply_desc }}</div>
            </div>
        </div>
        <div v-if="supplierPhone" class="phoneRow" @click.stop>
            <OrderPhone :phone="supplierPhone" />
        </div>
        <van-divider dashed :style="{ borderColor: '#1A3232' }"></van-divider>
        <div class="priceBox">
            <div style="font-weight:bold">$ {{ rows.orderservice ? rows.orderservice.total_price : '0.00' }}</div>
            <div v-if="showPlateApplyBtn" class="plateBtnBox" @click.stop>
                <van-button
                    size="small"
                    :disabled="plateApplyDisabled"
                    :color="plateApplyDisabled ? '#C8C8C8' : '#1E3C3E'"
                    :style="{ borderColor: plateApplyDisabled ? '#C8C8C8' : '#1E3C3E' }"
                    plain
                    @click.stop="onPlateApply"
                >
                    {{ plateApplyText }}
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin'
import OrderAddress from '@/components/Order/address.vue'
import OrderPhone from '@/components/Order/phone.vue'

export default {
    name: 'RefundItem',
    mixins: [myMixin],
    components: {
        OrderAddress,
        OrderPhone
    },
    props: {
        rows: {
            type: Object,
            default: () => ({})
        },
        showStatusTag: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        supplierName() {
            if (this.rows.supplierDetail && this.rows.supplierDetail.name) {
                return this.rows.supplierDetail.name
            }
            return ''
        },
        supplierAddress() {
            if (this.rows.supplierDetail && this.rows.supplierDetail.address) {
                return this.rows.supplierDetail.address
            }
            return ''
        },
        supplierPhone() {
            const d = this.rows && this.rows.supplierDetail
            if (!d) return ''
            return d.link_phone || d.phone || d.mobile || ''
        },
        supplierLat() {
            const d = this.rows && this.rows.supplierDetail ? this.rows.supplierDetail : {}
            const raw = d.latitude || d.lat || d.shop_lat
            const n = Number(raw)
            return Number.isFinite(n) ? n : ''
        },
        supplierLng() {
            const d = this.rows && this.rows.supplierDetail ? this.rows.supplierDetail : {}
            const raw = d.longitude || d.lng || d.shop_lng
            const n = Number(raw)
            return Number.isFinite(n) ? n : ''
        },
        refundState() {
            const s = this.rows && this.rows.status
            if (s && typeof s === 'object' && typeof s.value !== 'undefined') {
                return Number(s.value)
            }
            if (typeof s !== 'undefined' && s !== null && typeof s !== 'object') {
                return Number(s)
            }
            if (typeof this.rows.state !== 'undefined') return Number(this.rows.state)
            if (typeof this.rows.status_value !== 'undefined') return Number(this.rows.status_value)
            return null
        },
        plateStatusValue() {
            const p = this.rows && this.rows.plate_status
            if (p && typeof p === 'object' && typeof p.value !== 'undefined') {
                return Number(p.value)
            }
            if (typeof this.rows.plate_status_value !== 'undefined') return Number(this.rows.plate_status_value)
            return null
        },
        showPlateApplyBtn() {
            if (this.refundState !== 0) return false
            return this.plateStatusValue === 0 || this.plateStatusValue === 10
        },
        plateApplyDisabled() {
            return this.refundState === 0 && this.plateStatusValue === 10
        },
        plateApplyText() {
            if (this.refundState === 0 && this.plateStatusValue === 10) return 'Platform intervention in progress'
            return 'Request Platform Intervention'
        },
        statusLabel() {
            if (!this.showStatusTag) return ''
            const s = this.rows && this.rows.status
            const mappedByValue = this.getRefundStatusLabelByValue(this.refundState)
            if (mappedByValue) return mappedByValue
            if (s && typeof s === 'object' && s.text) {
                return this.translateRefundStatusText(s.text)
            }
            return 'In Progress'
        },
        statusColor() {
            if (!this.showStatusTag) return ''
            if (this.refundState === 10) return '#F90027'
            if (this.refundState === 30) return '#999999'
            return '#05A558'
        }
    },
    methods: {
        getMinute(minute, hour) {
            let min = minute || 0
            if (hour > 0) {
                min += hour * 60
            }
            return min
        },
        getRefundStatusLabelByValue(value) {
            const statusMap = {
                0: 'In Progress',
                10: 'Rejected',
                20: 'Completed',
                30: 'Cancelled'
            }
            return Object.prototype.hasOwnProperty.call(statusMap, value) ? statusMap[value] : ''
        },
        translateRefundStatusText(text) {
            const normalized = String(text || '').trim()
            const textMap = {
                '\u8fdb\u884c\u4e2d': 'In Progress',
                '\u5904\u7406\u4e2d': 'In Progress',
                '\u5f85\u5904\u7406': 'In Progress',
                '\u5df2\u62d2\u7edd': 'Rejected',
                '\u62d2\u7edd': 'Rejected',
                '\u5df2\u5b8c\u6210': 'Completed',
                '\u5b8c\u6210': 'Completed',
                '\u5df2\u53d6\u6d88': 'Cancelled',
                '\u53d6\u6d88': 'Cancelled',
                'In Progress': 'In Progress',
                'Rejected': 'Rejected',
                'Completed': 'Completed',
                'Cancelled': 'Cancelled'
            }
            return textMap[normalized] || normalized
        },
        goDetail() {
            this.$router.push({
                path: '/refundDetail',
                query: {
                    order_refund_id: this.rows.order_refund_id,
                    supplier_address: this.supplierAddress || ''
                }
            })
        },
        async onPlateApply() {
            if (this.plateApplyDisabled) return
            const id = this.rows && this.rows.order_refund_id
            if (!id) return
            try {
                const res = await this.$api.serviceRefundPlateApply({ order_refund_id: id })
                if (res && (res.code === 1 || res.code === 200)) {
                    this.$toast && this.$toast('Platform intervention request submitted')
                    this.$emit('refresh')
                } else {
                    const msg = (res && (res.msg || res.message)) || 'Application failed'
                    this.$toast && this.$toast(msg)
                }
            } catch (e) {
                console.error(e)
                this.$toast && this.$toast('Network error. Please try again later.')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.orderItem {
    width: 100%;
    font-size: .875rem;
    background: #fff;
    box-sizing: border-box;
    border-radius: .5rem;
    padding: 1rem;
    margin-bottom: 1rem;
    .dateGroup {
        width: 100%;
        height: auto;
        background: #F4F4F4;
        border-radius: .25rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 1rem;
        box-sizing: border-box;
        margin: 1rem 0;
        .dateItem {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 1rem;
            box-sizing: border-box;
            .applyDesc {
                margin-top: 0.5rem;
                font-size: 0.75rem;
                color: #999;
            }
        }
        .dateTime {
            display: flex;
            align-items: center;
            color: #666666;
            .line {
                margin: 0 0.2rem;
                background: #666666;
                width: .625rem;
                height: .0625rem;
            }
        }
    }
    .phoneRow{
        width: 100%;
        margin: 0.5rem 0;
    }
    .priceBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        .plateBtnBox{
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
